module.exports = __webpack_public_path__ + "media/src/assets/Images/Santander-710283743f1b06fd60828b52768751a1.svg";